import * as actionTypes from '@/store/actions.type';
import * as mutationTypes from '@/store/mutations.type';
import api from '@/api';
import JwtService from '@/common/jwt.service';
import ApiService from '@/api/service';

const token = JwtService.getToken();

const state = {
  isLoggedIn: !!token,
  token: token
};

const getters = {
  isLoggedIn: state => state.isLoggedIn,
  token: state => state.token,
  tokenData: (state, getters) => state.token
    ? JSON.parse(atob(getters.token.split('.')[1]))
    : null,
};

const actions = {
  async [actionTypes.LOGIN] ({ commit }, params) {
    const {data} = await api.auth.post(params);

    JwtService.saveToken(data.token);
    ApiService.setHeader();

    commit(mutationTypes.SET_AUTH, data.token);
  },
  [actionTypes.LOGOUT] ({ commit }) {
    JwtService.destroyToken();
    commit(mutationTypes.RESET_STATE);
  }
};

const mutations = {
  [mutationTypes.SET_AUTH] (state, payload) {
    state.isLoggedIn = true;
    state.token = payload;
  },
  [mutationTypes.RESET_STATE] (state, payload) {
    state.isLoggedIn = false;
    state.token = '';
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};